module.exports = __webpack_public_path__ + "static/img/title_about.f567e67.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/title_about.png
// module id = eeIX
// module chunks = 1